import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from '../PaymentDetails/DialCode';
import "./Subagents.css";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import { Base64 } from "js-base64";
import { useForm } from "react-hook-form";
import { setUserAgentUpdateData, getGeoInfo } from "../axios";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import Spinner from 'react-bootstrap/Spinner';
  export default function Agentuserupdate() {

    const [Newcountry, setCountry] = useState({});
    const [countrycode, setCountryCode] = useState({});
    const [Newcurrency, setCurrency] = useState({});
    const [ipaddress, setIpaddress] = useState({});
    const [sussessRegister, setSussessRegister] = useState(false);
    const [EmailRecheck, setEmailRecheck] = useState(false);
    const [PasswordMatchcheck, setPasswordMatchcheck] = useState(false);
    const [btnloader, setbtnloader] = useState(0);
    const [MobileCode, setMobileCode] = useState("");
    const [customerid, setCustomerid] = useState("");
    const [userID, setUserID] = useState("");
    const [agentUserData, setAgentUserData] = useState(null);
    const [checkedData, setCheckedData] = useState([]);
    const [DisablePayNowButton, setDisablePayNowButton] = useState(false);
    const {
      register,
      handleSubmit, watch,
      getValues,
      setValue,
      formState: { errors },
    } = useForm({
      mode: "onChange",
    });

      useEffect(() => {
        const userArr = localStorage.getItem("userDetails");
        const userArrNew = JSON.parse(userArr);
        const customer_id = userArrNew?.agent_id;

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const user_id = urlParams.get('user_id');
        setUserID(user_id);
        if(user_id >0){
          const agent_user_first_name = urlParams.get('agent_user_first_name');
          const agent_user_last_name = urlParams.get('agent_user_last_name');
          const agent_user_email = urlParams.get('agent_user_email');
          const agent_user_code = urlParams.get('agent_user_code');
          const agent_user_mobile_number = urlParams.get('agent_user_mobile_number');
          const agent_user_permission = urlParams.get('agent_user_permission');
         
          const newData = agent_user_permission.split(",");
          
            setCheckedData(newData);
           
        
          setValue("email", agent_user_email);
          setValue("number", agent_user_mobile_number);
          setMobileCode(agent_user_code);
          setValue("firstName", agent_user_first_name);
          setValue("lastName", agent_user_last_name);
          getGeoInfo().then(
              (data) => {
                  setCountry(data.country_name);
                  setCountryCode(data.country_calling_code);
                  setCurrency(data.country_name);
                  setIpaddress(data.ip);
              },
              (error) => {}
            );
            setCustomerid(customer_id);
           
        }
      
      }, []);
    
        const handleCheckboxChange = (e) => {
          const { value, checked } = e.target;
      
          if (checked) {
            setCheckedData([...checkedData, value]);
          } else {
            setCheckedData(checkedData.filter((item) => item !== value));
          }
        };
      
     
      let OnChangeMobileCode = (event) => {
      
        setMobileCode(event.target.value);
      };
       const password = useRef({});
          password.current = watch("password", "");   

          const onSubmit = (data) => {
            setDisablePayNowButton(true);
            let subData = true;
            setbtnloader(1);
            setTimeout(() => {
              if (subData) {
                  setSussessRegister(false);
                var MobileCodeData = MobileCode != ''? MobileCode: countrycode;
                  let first_name = data.firstName;
                  let last_name = data.lastName;
                  let email = data.email;
                 let mobile_number = data.number;
                 let country_code = MobileCodeData;
                 let checkdata = data.checkdata == false? checkedData:data.checkdata;
                 let customer_agent_id = customerid;
                 let user_id = userID;
               
                 setUserAgentUpdateData(first_name, last_name, email, mobile_number, country_code, customer_agent_id, checkdata,user_id).then(
                  (data) => {
                   
                     if(data == 1){
                      setSussessRegister(true);
                      const url = "/agentuser";
                      window.location.replace(url);
                      setbtnloader(0);
                     }
                  },
                  (error) => {
          
                  }
              );
                 
              }
      
            }, 3000);
          }
  
    
    return (
      
      <div>
        <Helmet>
          <title> User Agent @ Holiday Seychelles</title>
          <meta
            name="description"
            content="Plan your honeymoon in one of the beautiful places in the world - Holiday Seychelles."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          {" "}
          User Agent @ Holiday Seychelles
        </h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div
            className="reviewPlanned"
            style={{ marginTop: "-35px", height: "85px" }}
          >
            <div className="landingContainer"></div>
          </div>

         
          <div className="contentWrapper myTrips">
            <div>
              <div className="tripListingWrap">
                <div>
                  <div className="myTripLstngLobCrd forUpcoming">
                    <div className="Container-TileUser" style={{height: '350px !important'}}>
                      <div className="ContainerFlex">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div class="container">
                          <div class="row">
                            <div className="contentWrapper"
                              style={{
                                overflowY: "auto",
                                width: "1100px"
                              }}
                            >
                              <div className="container">
                                <div className="row">
                                  <div class="" role="alert">
                                  <span className="font16 latoBlack capText">
                                       User Update
                                        </span>
                                  </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>Email</label>

                                      <input   type="email"
                                  className={`frmTextInput ${
                                    errors.email && "Err"
                                  }`}
                                  {...register("email", {
                                    required: true,
                                    minLength: 2,
                                    pattern:
                                      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
                                  })}
                                  id="email"
                                  name="email"
                                  placeholder="Enter Email"
                                  readOnly
                                />
                                    {errors.email &&
                                  errors.email.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Email
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Email must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter a valid email address
                                    </span>
                                  )}

                                {EmailRecheck && (
                                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                    This email id already exist
                                  </span>
                                )} 
                                     
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>Contact Number</label>

                                <div className="paymakeFlex textLtr" style={{display:'flex'}}>
                                    <div className="guestDtls__contact">
                                        <label for="mCode" className="frmSelectCont__contact">
                                            <select id="mCode" className="frmSelect frmSelectContact frmTextInput"   value={MobileCode}
                                  onChange={OnChangeMobileCode}>
                                          
                                    {DialCode.map((item, key) => (
                                        <option value={item.dial_code}>{item.name}&nbsp;({item.dial_code})</option>
                                    ))}
                                            </select>
                                        </label>
                                        <span className="selectedCode" id="dialCode" style={{padding: '10px'}}>
                                {MobileCode == "" ? +91: MobileCode}
                              </span>
                                        <input type="hidden" id="countryCode" name="countryCode" value={MobileCode == "" ? +91: MobileCode}/>
                                    </div>
                                    <div className="flexOne">
                                        <div className="textFieldCol ">
                                        <input
                                  type="number"
                                  className={`frmTextInput noLeftBorder frmTextInput ${
                                    errors.number && "Err"
                                  }`}
                                  {...register("number", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 15,
                                    pattern: /^[0-9]+$/i,
                                  })}
                                  id="number"
                                  name="number"
                                  placeholder="Enter Contact Number"
                                />
                               
                                {errors.number &&
                                  errors.number.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Contact Number
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number must be at least 6
                                      characters long!
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number should be less then 15
                                      characters !
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only number
                                    </span>
                                  )}

    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>First Name</label>

                                      <input
                                  type="text"
                                  className={`frmTextInput ${
                                    errors.firstName && "Err"
                                  }`}
                                  {...register("firstName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="firstName"
                                  name="firstName"
                                  placeholder="Enter First Name"
                                />
                               
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your First Name
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name must be at least 2 characters
                                      long!
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name should be less then  50
                                      characters !
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}
                                      
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div
                                      className="form-group"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <label>Last Name</label>
                                      <input
                                  type="text"
                                  className={`frmTextInput ${
                                    errors.lastName && "Err"
                                  }`}
                                  {...register("lastName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="lastName"
                                  name="lastName"
                                  placeholder="Enter Last Name"
                                />
                                
                                {errors.lastName &&
                                  errors.lastName.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Last Name
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name should be less then 50 characters
                                      !
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}
                                     
                                    </div>
                                  </div>
                                  <div class="users-agent-form__options">
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="active"  checked={checkedData.includes('active')} onChange={handleCheckboxChange} />
                                        <span>Active</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="administrator"
                                        checked={checkedData.includes('administrator')} onChange={handleCheckboxChange} />
                                        <span>Administrator</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="make"
                                        checked={checkedData.includes('make')} onChange={handleCheckboxChange} />
                                        <span>Make bookings</span>
                                    </label>
                                    <label class="users-agent-form__options-item">
                                        <input type="checkbox" {...register("checkdata")} value="cancel"
                                        checked={checkedData.includes('cancel')} onChange={handleCheckboxChange} />
                                        <span>Cancel bookings</span>
                                    </label>
                                   
                                   
                                </div>
                               
                                  <div
                                    id="pass-info"
                                    className="clearfix"
                                  ></div>
                                 <div className="col-12" style={{ marginTop: 20 }}>
                                  <div className="col-12 text-center">
                                    {" "}
                                    <button type="submit" class="primaryBtn2 appendBottom15" disabled={DisablePayNowButton}>Update &nbsp; {btnloader == 1 && (<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" visually-hidden="true"/>)}</button>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        </form>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    );
   }

